import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  useDataPath,
} from '@agilelab/plugin-wb-platform';
import preview from './preview/practice_shaper_content/practice_shaper_content.png';
import thumbnail from './preview/practice_shaper_content/practice_shaper_content_thumbnail.png';
import { generateEntityFields } from '@agilelab/plugin-wb-builder-catalog';

CustomViewPages.register({
  id: 'practice_shaper_content',
  meta: {
    label: 'Practice Shaper Detail Drawer',
    category: CustomViewPageCategory.PRACTICE_SHAPER,
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  function: function Entity() {
    const data = useDataPath('');
    // TODO: this needs to be fixed, custom view content should be static and any conditional logic should be implemented using <CustomViewComponent /> attributes such as "showWhen".
    const genFields = generateEntityFields(data);

    return (
      <CustomViewComponent type="catalog_system_card">
        <CustomViewComponent type="container">
          {genFields}
          <CustomViewComponent
            type="hline"
            showWhen={{
              value: '{{ tags.length }}',
              notEquals: 0,
            }}
          />
          <CustomViewComponent
            type="tags"
            label="Tags"
            path="tags"
            showWhen={{
              value: '{{ tags.length }}',
              notEquals: 0,
            }}
          />
        </CustomViewComponent>
      </CustomViewComponent>
    );
  },
});
